import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Actions, Store, ofActionDispatched } from '@ngxs/store';

import { Logout } from '@data/state';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<router-outlet />`,
})
export class App implements OnInit {
    private readonly _actions = inject(Actions);
    private readonly _store = inject(Store);
    private readonly _router = inject(Router);

    ngOnInit(): void {
        this.redirectOnLogout();
        this.multiTabLogout();
    }

    private redirectOnLogout(): void {
        this._actions.pipe(ofActionDispatched(Logout)).subscribe(() => {
            this._router.navigate(['auth/login']);
        });
    }

    private multiTabLogout(): void {
        window.addEventListener('storage', (event) => {
            if (event.storageArea === localStorage && event.key === 'auth') {
                const auth = localStorage.getItem('auth');
                if (!auth) {
                    this._store.dispatch(new Logout());
                }
            }
        });
    }
}
